/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lesson_Field_PriceInputs */

const en_lesson_field_price = /** @type {(inputs: Lesson_Field_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price`)
};

const he_lesson_field_price = /** @type {(inputs: Lesson_Field_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחיר`)
};

/**
* | output |
* | --- |
* | "Price" |
*
* @param {Lesson_Field_PriceInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lesson_field_price = /** @type {((inputs?: Lesson_Field_PriceInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lesson_Field_PriceInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lesson_field_price(inputs)
	return he_lesson_field_price(inputs)
});